<template>
  <div class="footer">
    <Button :class="[classBtn]" id="footer-btn" @click="handleClick">
      <Icon v-if="showIcon && iconName" :name="iconName"/>
      <span>{{ btnText }}</span>
    </Button>
  </div>
</template>

<script>
import Button from '@/components/ui/AppButton.vue';
import Icon from '@/components/ui/AppIcon.vue';

export default {
  name: 'step-info-footer',
  components: { Button, Icon },
  props: {
    btnText: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      required: true,
    },
    showIcon: {
      type: Boolean,
      required: true,
    },
    classBtn: {
      type: String,
    },
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>

<style lang="scss" scoped>
  .footer {
    margin: 0;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    position: fixed;
    width: 100%;
    height: 88px;
    padding: 20px 24px;

    img {
      height: 24px;
      width: 24px;
    }

    span {
      padding-left: 8px;
    }

    & #footer-btn {
      width: 100%;
      height: 100%;
    }
  }

  .primary-light {
    background: var(--primary-light);

    span {
      color: var(--primary);
      font-weight: bold;
    }
  }
</style>
